<div class="full-width sticky-list-header">
    <curafida-search-and-button
        (openFilterModal)="openFilterModal()"
        (setButtonAction)="openNoteDetail()"
        (updates)="processFilterUpdate($event)"
        [buttonIcon]="addNoteButtonIcon"
        [filterLength]="filterCount()"
        [hideFilter]="false"
        [hideSearch]="false"></curafida-search-and-button>
</div>
<div class="full-width">
    <curafida-table
        (openDetail)="openNoteDetail($event)"
        (updateTable)="processTableUpdate($event)"
        [isLoading]="{ success: isLoadingSuccess(), processing: isLoading() }"
        [listTableConfig]="noteTableConfig">
    </curafida-table>
</div>
